import { createContext } from 'react'

const AccordionContext = createContext(null)

export default AccordionContext
